(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["como-funciona-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function play(btn) {
      var src = btn.getAttribute('data-embed');
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.className = 'lacttiva-how__media';
      btn.replaceWith(iframe);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.lacttiva-how__facade') : null;
      if (btn) { e.preventDefault(); play(btn); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-nuevo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlider(root) {
      if (!root || root.dataset.heroSliderInit === 'true') return;
      var track = root.querySelector('.lacttiva-hero__slides');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.lacttiva-hero__slide'));
      if (slides.length <= 1) {
        if (slides[0]) slides[0].classList.add('is-active');
        return;
      }
      root.dataset.heroSliderInit = 'true';

      var dotsWrap = root.querySelector('.lacttiva-hero__dots');
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.lacttiva-hero__dot')) : [];

      var index = 0;
      var count = slides.length;
      var autoplay = root.dataset.autoplay === 'true';
      var interval = parseInt(root.dataset.interval, 10) || 5000;
      var timer = null;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(i) {
        index = (i + count) % count;
        slides.forEach(function (s, k) {
          var on = k === index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, k) {
          var on = k === index;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }
      function next() { go(index + 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!autoplay || reduce) return;
        stop();
        timer = setInterval(next, interval);
      }

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { go(k); start(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      // Exponer para el editor de Shopify
      root.heroGo = go;
      root.heroStop = stop;

      go(0);
      start();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('.lacttiva-hero[data-slider="true"]');
      Array.prototype.forEach.call(roots, initHeroSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    // Al seleccionar un bloque en el editor, saltar a esa diapositiva
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('.lacttiva-hero__slide') : null;
      if (!slide) return;
      var root = slide.closest('.lacttiva-hero');
      if (!root || typeof root.heroGo !== 'function') return;
      var arr = Array.prototype.slice.call(root.querySelectorAll('.lacttiva-hero__slide'));
      var idx = arr.indexOf(slide);
      if (idx >= 0) { root.heroStop(); root.heroGo(idx); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lacttiva-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWA(root) {
      if (!root || root.dataset.waInit === '1') return;
      root.dataset.waInit = '1';

      var widget = root.querySelector('.lacttiva-wa');
      if (!widget) return;

      var designMode = window.Shopify && window.Shopify.designMode;
      var delay = parseInt(root.dataset.delay || '0', 10);

      if (delay > 0 && !designMode) {
        widget.classList.add('is-hidden-initial');
        setTimeout(function () {
          widget.classList.remove('is-hidden-initial');
          widget.classList.add('is-visible');
        }, delay * 1000);
      } else {
        widget.classList.add('is-visible');
      }

      // Globo de saludo descartable (recordado por sesión)
      var bubble = root.querySelector('.lacttiva-wa__bubble');
      var closeBtn = root.querySelector('.lacttiva-wa__bubble-close');
      var key = 'lacttiva-wa-bubble-dismissed';

      if (bubble) {
        try {
          if (sessionStorage.getItem(key) === '1' && !designMode) {
            bubble.style.display = 'none';
          }
        } catch (e) {}

        if (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            bubble.style.display = 'none';
            try { sessionStorage.setItem(key, '1'); } catch (err) {}
          });
        }
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.lacttiva-wa-root').forEach(initWA);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var t = e.target.querySelector ? e.target : document;
      // Reinicia por si el editor recarga la sección
      t.querySelectorAll('.lacttiva-wa-root').forEach(function (r) {
        r.dataset.waInit = '';
      });
      initAll(t);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
